import { EditDataTypesEnum } from '@coin/shared/employee-data/util';
import { HeadcountSettingDropdownItemsType } from '../../enums/headcount-setting-dropdown-items-type.enum';
import { HeadcountSettingConfig, HeadcountSettingItem } from '../../interfaces/headcount-approval-admin-settings.model';

const HEADCOUNT_ADMIN_SETTINGS_MAIL_TASK_CONFIG_DUE_DATE: HeadcountSettingItem = {
  title: 'headcount-settings.due-date',
  content: [
    {
      key: 'requesterConfirmationDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.requester-confirmation-due-date'
    },
    {
      key: 'nMinusOneDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.nminus1-due-date'
    },
    {
      key: 'nMinusTwoDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.nminus2-due-date'
    },
    {
      key: 'regionalOrGlobalBusinessPartnerDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.regional-or-global-hrbp-due-date'
    },
    {
      key: 'headOneDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head1-due-date'
    },
    {
      key: 'headTwoDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head2-due-date'
    },
    {
      key: 'headNOneDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head-nminus1-due-date'
    },
    {
      key: 'headNTwoDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head-nminus2-due-date'
    },
    {
      key: 'headNThreeDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head-nminus3-due-date'
    },
    {
      key: 'gidApproverDueDateDelay',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.gid-approver-due-date'
    }
  ]
};
const HEADCOUNT_ADMIN_SETTINGS_NON_GERMAN_SENIORS: HeadcountSettingItem = {
  title: 'headcount-settings.questionnaire-disabled-for-german-non-seniors',
  content: [
    {
      key: 'isQuestionnaireDisabledForGermanWithPartialEvaluation',
      type: EditDataTypesEnum.BOOLEAN,
      label: 'master-data.headcount-settings.questionnaire-disabled-for-german-non-seniors'
    }
  ]
};

const HEADCOUNT_ADMIN_SETTINGS_MAIL_TASK_CONFIG_REMINDER_DATE: HeadcountSettingItem = {
  title: 'headcount-settings.reminder-date',
  content: [
    {
      key: 'requesterConfirmationReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.requester-confirmation-reminder-date'
    },
    {
      key: 'nMinusOneReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.nminus1-reminder-date'
    },
    {
      key: 'nMinusTwoReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.nminus2-reminder-date'
    },
    {
      key: 'regionalOrGlobalBusinessPartnerReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.regional-or-global-hrbp-reminder-date'
    },
    {
      key: 'headOneReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head1-reminder-date'
    },
    {
      key: 'headTwoReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head2-reminder-date'
    },
    {
      key: 'headNOneReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head-nminus1-reminder-date'
    },
    {
      key: 'headNTwoReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head-nminus2-reminder-date'
    },
    {
      key: 'headNThreeReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.head-nminus3-reminder-date'
    },
    {
      key: 'gidApproverReminderLeadTime',
      type: EditDataTypesEnum.TEXT,
      label: 'master-data.headcount-settings.gid-approver-reminder-date'
    }
  ]
};

export const HEADCOUNT_ADMIN_SETTINGS: HeadcountSettingConfig = {
  items: [
    HEADCOUNT_ADMIN_SETTINGS_NON_GERMAN_SENIORS,
    {
      title: 'headcount-settings.workflow-settings',
      content: [
        {
          key: 'approvedEmailId',
          type: EditDataTypesEnum.DROPDOWN,
          label: 'master-data.headcount-settings.approved-template',
          dropdownType: HeadcountSettingDropdownItemsType.Mail
        },
        {
          key: 'rejectedEmailId',
          type: EditDataTypesEnum.DROPDOWN,
          label: 'master-data.headcount-settings.rejected-template',
          dropdownType: HeadcountSettingDropdownItemsType.Mail
        },
        {
          key: 'vetoEmailId',
          type: EditDataTypesEnum.DROPDOWN,
          label: 'master-data.headcount-settings.veto-template',
          dropdownType: HeadcountSettingDropdownItemsType.Mail
        },
        {
          key: 'notificationEmailId',
          type: EditDataTypesEnum.DROPDOWN,
          label: 'master-data.headcount-settings.active-or-pending-template',
          dropdownType: HeadcountSettingDropdownItemsType.Mail
        }
      ]
    },
    HEADCOUNT_ADMIN_SETTINGS_MAIL_TASK_CONFIG_DUE_DATE,
    HEADCOUNT_ADMIN_SETTINGS_MAIL_TASK_CONFIG_REMINDER_DATE
  ]
};
